export class MaterialPutRequest {
  materialId: string
  fileName: string

  constructor(materialId: string, fileName: string) {
    this.materialId = materialId
    this.fileName = fileName
  }
}
